import { lazy } from "react";
import { Route } from "../../RouteModel";
import { cashManagementAccountRoutes } from "./cashManagementAccount";
import { cashManagementProviderConfigRoutes } from "./cashManagementProviderConfig";

const CashManagementSettingsDetails = lazy(
  () => import("../../../pages/configuration/customers/cash-management/Details")
);

const CashManagementNotificationsSettings = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/EditNotificationsSettings"
    )
);

export const cashManagementRoutes: Route[] = [
  {
    i18nName: "Cash management",
    path: "/configuration/customers/:id/cash-management",
    component: CashManagementSettingsDetails,
  },
  ...cashManagementAccountRoutes,
  ...cashManagementProviderConfigRoutes,
  {
    i18nName: "Edit notifications settings - Cash management",
    path: "/configuration/customers/:id/cash-management/notifications-settings",
    component: CashManagementNotificationsSettings,
  },
];
